import * as Sentry from "@sentry/react";

const DSN = "https://bfa0443d3ca9d918e9ded60b94ee04a8@sentry.thelargest.site/2";

declare const __APP_VERSION__: string;
declare const __APP_ENV__: string;

export const initSentry = () => {
  if (import.meta.env.DEV) return;

  Sentry.init({
    dsn: DSN,
    release: __APP_VERSION__,
    environment: __APP_ENV__ || "production",

    beforeSend(event) {
      const blacklist = [
        "accessToken",
        "refreshToken",
        "authorization",
        "apiKey",
        "password",
      ];
      const scrub = (obj: any) => {
        if (!obj || typeof obj !== "object") return obj;
        for (const k of Object.keys(obj)) {
          if (blacklist.includes(k.toLowerCase())) obj[k] = "***";
          else if (typeof obj[k] === "object") scrub(obj[k]);
        }

        return obj;
      };

      if (event.request) scrub(event.request);

      if (event.user) scrub(event.user);

      if (event.extra) scrub(event.extra);

      if (event.contexts) scrub(event.contexts);

      return event;
    },
  });
};
